const configTheme = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

export default configTheme;
